import Button from "components/Button";
import Checkbox from "components/Checkbox";
import ImageSlider from "components/ImageSlider";
import Link from "components/Link";
import Text from "components/Text";
import TextInput from "components/TextInput";
import { config } from "config";
import { memo } from "react";
import theme from "theme";
import * as Styled from "../shared";
import { DescribeYourself } from "./DescribeYourself/DescribeYourself";
import { StepBar, StepBarSection } from "./SignUp.styled";
import { useSignUp } from "./useSignUp";

export const SignUp = memo(() => {
    const {
        inputs,
        onSubmit,
        handleInputChange,
        inputErrors,
        isLoading,
        toggleCheckbox,
        activeStep,
        userType,
        handleGoBack,
        handleUserTypeChange,
        onFinalSubmit,
    } = useSignUp();

    return (
        <Styled.Wrapper>
            <Styled.LeftWrapper>
                <Styled.Card>
                    <StepBarSection>
                        <StepBar isActive={activeStep === 1} />
                        <StepBar isActive={activeStep === 2} />
                    </StepBarSection>
                    {activeStep === 1 ? (
                        <>
                            <Text variant="heading5" align="center" fullWidth>
                                Sign Up
                            </Text>
                            <Styled.Form onSubmit={onSubmit}>
                                <TextInput
                                    type="text"
                                    name="firstName"
                                    label="First Name"
                                    required
                                    placeholder="John"
                                    fullWidth
                                    labelColor={theme.colors.text}
                                    value={inputs.firstName}
                                    onChange={handleInputChange}
                                    errorMsg={inputErrors.firstName}
                                />
                                <TextInput
                                    type="text"
                                    name="lastName"
                                    label="Last Name"
                                    required
                                    placeholder="Doe"
                                    fullWidth
                                    labelColor={theme.colors.text}
                                    value={inputs.lastName}
                                    onChange={handleInputChange}
                                    errorMsg={inputErrors.lastName}
                                />
                                <TextInput
                                    type="email"
                                    name="email"
                                    label="Email"
                                    required
                                    placeholder="user@email.com"
                                    fullWidth
                                    labelColor={theme.colors.text}
                                    value={inputs.email}
                                    onChange={handleInputChange}
                                    errorMsg={inputErrors.email}
                                />
                                <TextInput
                                    type="password"
                                    name="password"
                                    label="Password"
                                    required
                                    autoComplete="new-password"
                                    placeholder="********"
                                    fullWidth
                                    labelColor={theme.colors.text}
                                    value={inputs.password}
                                    onChange={handleInputChange}
                                    errorMsg={inputErrors.password}
                                />
                                <TextInput
                                    type="password"
                                    name="passwordConfirmation"
                                    label="Confirm Password"
                                    required
                                    placeholder="********"
                                    fullWidth
                                    labelColor={theme.colors.text}
                                    value={inputs.passwordConfirmation}
                                    onChange={handleInputChange}
                                    errorMsg={inputErrors.passwordConfirmation}
                                />
                                <Styled.CheckboxWrapper>
                                    <Checkbox
                                        size="XS"
                                        fullWidth
                                        label="I agree to Alimitless's"
                                        labelColor="#8A8A8A"
                                        checked={
                                            inputs.isTermsAndConditionsAgree
                                        }
                                        onChange={toggleCheckbox}
                                    />
                                    <Styled.TermsAndConditionsLink
                                        href={`${process.env.REACT_APP_WEBSITE_URL}/terms-and-conditions`}
                                        color={theme.colors.text}
                                        underline
                                        target="_blank"
                                    >
                                        <Text variant="label">T&C</Text>
                                    </Styled.TermsAndConditionsLink>
                                </Styled.CheckboxWrapper>
                                <Button
                                    type="submit"
                                    variant="filled"
                                    fullWidth
                                    textColor={theme.colors.white}
                                    textVariant="button2"
                                >
                                    Next
                                </Button>
                            </Styled.Form>
                            <Text
                                variant="label"
                                color="#BDBDBD"
                                align="center"
                                fullWidth
                            >
                                I already have an account.{"  "}
                                <Link
                                    variant="label"
                                    color={theme.colors.text}
                                    href="/login"
                                    underline
                                >
                                    Login
                                </Link>
                            </Text>
                        </>
                    ) : (
                        <DescribeYourself
                            userType={userType}
                            isLoading={isLoading}
                            handleBack={handleGoBack}
                            handleDone={onFinalSubmit}
                            handleUserTypeChange={handleUserTypeChange}
                        />
                    )}
                    {/* <Styled.Hr />
                    <Text
                        variant="label"
                        color="#BDBDBD"
                        fullWidth
                        align="center"
                    >
                        or login with
                    </Text> */}
                </Styled.Card>
                <Styled.CompanyNameContainer>
                    <Styled.CompanyName href="https://www.strydden.com/" target="_blank">
                        Made with &#9829; by Strydden
                    </Styled.CompanyName>
                </Styled.CompanyNameContainer>
            </Styled.LeftWrapper>
            <Styled.RightWrapper>
                <ImageSlider sliderImages={config.sliderImages} />
            </Styled.RightWrapper>
        </Styled.Wrapper>
    );
});
